import { Component, OnInit } from '@angular/core';
import {TemplatePromptsService} from "../../services/template-prompts.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-lista-templates-prompts',
  templateUrl: './lista-templates-prompts.component.html',
  styleUrls: ['./lista-templates-prompts.component.scss']
})
export class ListaTemplatesPromptsComponent implements OnInit {
  templatePrompts = [
  ];
  carregando: boolean;

  constructor(private templatePromptsService: TemplatePromptsService,
              private router: Router) { }

  ngOnInit(): void {
    this.carregando = true;
    this.carregueTemplatesPrompts().then( () => {
      this.carregando = false;
    }).catch( () => {
      this.carregando = false;
    });
  }

  // carregue os templateprompts do servidor /templatesprompts/liste
  carregueTemplatesPrompts() {
    return new Promise( (resolve, reject) => {
      this.templatePromptsService.liste().then((resposta) => {
        this.templatePrompts = resposta;

        // processe os templates prompts e formate o template com negrito onde tiver ${}
        this.templatePrompts.forEach( (templatePrompt) => {
          templatePrompt.template = this.formateTemplate(templatePrompt.template);
          templatePrompt.template = this.boldWords(templatePrompt.template);
        });
        resolve(true);
      }).catch( (erro) => {
        reject(erro);
      });
    });
  }

  private formateTemplate(template: string) {
    const regex = /\${(.*?)}/g;
    let match;

    while ((match = regex.exec(template)) !== null) {
      template = template.replace(match[0], `<b>\$\{${match[1]}\}</b>`);
    }

    return template;
  }

  boldWords(text: string): string {
    text = text.replace(/\[(.*?)\]/g, '<strong>[$1]</strong>');
    text = text.replace(/\${(.*?)}/g, '<strong>${$1}</strong>');
    text = text.replace(/CUPOM::(.*?)/g, '<strong>CUPOM::$1</strong>');
    text = text.replace(/\n/g, '<br>');
    return text;
  }

  editarTemplatePrompt(dataItem: any) {
    this.router.navigate(['/admin/templates-prompts/nova/', dataItem.id]);
  }
}
